module.exports = __webpack_public_path__ + "static/media/serverless-szkolenie.b2726d51.jpg";